import { jsonObject, jsonArrayMember } from 'typedjson';
import { Teammate } from './teammate';

@jsonObject
export class TeammateResult {
  @jsonArrayMember(Teammate)
  public data: Teammate[];
}
